/* eslint-disable no-unused-vars */
import React from 'react';
import style from './searchInput.module.scss';

export type SearctInputProps = {
  isDisabled: boolean;
  setIsOpen: (value: React.SetStateAction<boolean>) => void;
  setSearch: (value: React.SetStateAction<string>) => void;
  search: string;
  placeholder?: string;
};

export default function SearchInput({
  isDisabled = false,
  setIsOpen,
  setSearch,
  search = '',
  placeholder = 'Например: #электробус',
}: SearctInputProps) {
  return (
    <input
      disabled={isDisabled}
      className={style.container}
      type="text"
      placeholder={placeholder}
      onFocus={() => {
        setIsOpen(true);
      }}
      value={search}
      onChange={(e) => {
        setIsOpen(true);

        const cleared = e.currentTarget.value
          .toLowerCase()
          .replace(/[^a-zа-я0-9]/g, '');
        setSearch(cleared);
      }}
    ></input>
  );
}
